import React from 'react'
import BlackButton from '../../../components/forms/blackfillButton'
import LightButton from '../../../components/forms/lightfillButton'

const PageNav = ({page,setPage,add_admin}) => {
  return (
    <div className='product_create_pagenav_container'>
      {page !== 0 && page < 2 &&
        <>
            <LightButton Value={"Back"} Action={()=>{setPage(page-1);}} />
            <BlackButton Value={"Next"} Action={()=>{setPage(page+1);}}/>
        </>
      }
      {page >= 2 &&
        <>
            <LightButton Value={"Back"} Action={()=>{setPage(page-1);}} />
            <BlackButton Value={"Skip Phone"} Action={()=>{add_admin();}}/>
        </>
      }
    </div>
  )
}

export default PageNav
